import {
    onboardingFilterOptions,
    onboardingSortOptions,
} from '../tables/config/onboardingColumns';
import {
    trialFilterOptions,
    trialSortOptions,
} from '../tables/config/trialColumns';
import {
    activeFilterOptions,
    activeSortOptions,
} from '../tables/config/activeColumns';
import type {
    FacilityStageKey,
    StageFilterOption,
    StageSortOption,
} from '../tables/utils/facilityTableTypes';

export const STAGE_TABS: Array<{
    value: 'all' | FacilityStageKey;
    label: string;
}> = [
    { value: 'all', label: 'All' },
    { value: 'onboarding', label: 'Onboarding' },
    { value: 'trial', label: 'Trial' },
    { value: 'active', label: 'Subscription' },
];

export const CHIP_ACTIVE = 'border-zinc-200 bg-zinc-100 text-zinc-950 shadow-sm';
export const CHIP_INACTIVE =
    'border-white/[0.14] bg-white/[0.06] text-muted-foreground hover:border-white/[0.22] hover:bg-white/[0.09] hover:text-foreground';

export function getStageConfig(stage: FacilityStageKey): {
    filterOptions: StageFilterOption[];
    sortOptions: StageSortOption[];
} {
    switch (stage) {
        case 'onboarding':
            return {
                filterOptions: onboardingFilterOptions,
                sortOptions: onboardingSortOptions,
            };
        case 'trial':
            return {
                filterOptions: trialFilterOptions,
                sortOptions: trialSortOptions,
            };
        case 'active':
            return {
                filterOptions: activeFilterOptions,
                sortOptions: activeSortOptions,
            };
    }
}

export function getDefaultSort(stage: FacilityStageKey): string {
    switch (stage) {
        case 'onboarding':
            return '';
        case 'trial':
            return 'trial-ending';
        case 'active':
            return '';
    }
}
